var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D78",
    d: "m11.99 21.55 1.24-6.22-4.76 4.19a2.05 2.05 0 1 1-2.01-3.49L12.47 14l-6.01-2.03a2.05 2.05 0 1 1 2-3.49l4.77 4.2L12 6.44a2.05 2.05 0 1 1 4.02 0l-1.25 6.23 4.77-4.2a2.05 2.05 0 1 1 2.01 3.49l-6 2.03 6 2.03a2.05 2.05 0 1 1-2 3.48l-4.77-4.19L16 21.55a2.05 2.05 0 1 1-4.02 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoliday);
export default __webpack_public_path__ + "static/media/Holiday.5148dbef072c4fa9df42b2eff482056a.svg";
export { ForwardRef as ReactComponent };